export const sortSegmentsData = (cohorts = []) => {
  const groupedSegments = cohorts.reduce(
    (result, item) => {
      if (item.cohort === 'all_users') {
        result.all.push(item);
      } else if (item.impact) {
        result.impact.push(item);
      } else {
        result.rest.push(item);
      }

      return result;
    },
    { impact: [], all: [], rest: [] }
  );

  return {
    sortedSegments: groupedSegments.impact.concat(groupedSegments.all, groupedSegments.rest),
    groupedSegments,
  };
};
